import React from 'react'
import style from './styles/no_results.module.scss'

interface IProps {
  text?: string
}

const NoSearchResults = ({ text = 'По Вашему запросу ничего не найдено' }: IProps): React.ReactElement => {
  return <p className={style.no_results}>{text}</p>
}

export default NoSearchResults
